import numeral from 'numeral';

export function fixDateTime(value: string, options?: { displayTime: boolean }) {
  const { displayTime = true } = options || {};
  const dateTimeArray = value.split(' ');

  if (!displayTime) dateTimeArray.pop();

  return dateTimeArray.reverse().join(' | ');
}

export function withSeparator(value: string) {
  return numeral(value).format('0,0');
}
